import { TextInput, useDripsyTheme } from 'dripsy';
import * as React from 'react';
import { Platform, } from 'react-native';
import { getSizeBasedOnFontScale } from '../utils/common';
export const StyledInput = React.forwardRef(({ isDisabled, isInvalid, isRequired, isSuccess, id, helperTextId, multiline, numberOfLines, sx, onFocus, onBlur, ...props }, forwardedRef) => {
    const theme = useDripsyTheme().theme;
    const placeholderTextColor = theme.colors['secondaryBackgroundActive'];
    const [isFocusVisible, setFocusVisible] = React.useState(false);
    const getTextareaHeight = (rows = 8) => {
        const { lineHeight, paddingTop, paddingBottom, borderWidth } = theme.forms.textarea;
        const paddingY = theme.sizes[paddingTop] + theme.sizes[paddingBottom];
        const rowsHeight = theme.lineHeights[lineHeight] * rows;
        const height = rowsHeight + paddingY + borderWidth * 2;
        return getSizeBasedOnFontScale(height);
    };
    return (React.createElement(TextInput, { ref: forwardedRef, nativeID: id, editable: !isDisabled, variant: multiline ? 'textarea' : 'input', multiline: multiline, numberOfLines: numberOfLines, onFocus: (event) => {
            if (onFocus)
                onFocus(event);
            setFocusVisible(true);
        }, onBlur: (event) => {
            if (onBlur)
                onBlur(event);
            setFocusVisible(false);
        }, placeholderTextColor: placeholderTextColor, sx: {
            ...(!multiline && { height: getSizeBasedOnFontScale(theme.sizes['$8']) }),
            ...(multiline &&
                Platform.select({ native: { height: getTextareaHeight(numberOfLines) } })),
            ...(Platform.OS === 'web' && { outlineStyle: 'none' }),
            ...(isSuccess && { borderColor: 'successBackground' }),
            ...(isInvalid && { borderColor: 'errorBackground' }),
            ...(isFocusVisible && { borderColor: 'infoBorder' }),
            ...(isDisabled && {
                backgroundColor: 'secondaryBackgroundDisabled',
                borderColor: 'secondaryBackgroundDisabled',
                color: 'secondaryBackgroundActive',
                cursor: 'not-allowed',
                ...(Platform.OS === 'web' && {
                    opacity: 1,
                    '-webkit-text-fill-color': placeholderTextColor,
                }),
            }),
            ...sx,
        }, ...Platform.select({
            web: {
                disabled: isDisabled,
                required: isRequired,
                'aria-required': isRequired,
                'aria-invalid': isInvalid,
                'aria-describedby': helperTextId,
            },
            native: {
                accessibilityState: { disabled: isDisabled },
                ...(multiline && { textAlignVertical: 'top' }),
            },
        }), ...props }));
});
StyledInput.displayName = 'StyledInput';
//# sourceMappingURL=StyledInput.js.map